var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-img',{attrs:{"src":_vm.src,"max-width":this.maxHeight,"height":_vm.height},on:{"load":function($event){return _vm.$redrawVueMasonry()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }